import { render, staticRenderFns } from "./breedHealth.vue?vue&type=template&id=2e60c258&scoped=true&"
import script from "./breedHealth.vue?vue&type=script&lang=js&"
export * from "./breedHealth.vue?vue&type=script&lang=js&"
import style0 from "./breedHealth.vue?vue&type=style&index=0&id=2e60c258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60c258",
  null
  
)

export default component.exports